import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=5ec8c5e6"
import script from "./DateInput.vue?vue&type=script&lang=ts"
export * from "./DateInput.vue?vue&type=script&lang=ts"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=5ec8c5e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/shared/_locales/DateInput.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FDateInput.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports